import { c as _c } from "react/compiler-runtime";
import * as TooltipPrimitive from '@radix-ui/react-tooltip';
import type { ReactNode } from 'react';
export type BlockedComposerProps = {
  pills: ReactNode;
  input: ReactNode;
  message: string;
};

// Radix is used directly (not the ui Tooltip) so the trigger can be the full-size overlay — the
// ui wrapper's inline-block trigger collapses to zero height and never receives hover.
const BlockedComposer = t0 => {
  const $ = _c(14);
  const {
    pills,
    input,
    message
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="absolute inset-0 z-20 cursor-not-allowed" aria-hidden="true" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== pills) {
    t2 = <div className="relative w-full flex justify-center">{pills}{t1}</div>;
    $[1] = pills;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <TooltipPrimitive.Trigger asChild={true}><div data-testid="percy-blocked-overlay" className="absolute inset-0 z-20 cursor-not-allowed" aria-hidden="true" /></TooltipPrimitive.Trigger>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== input) {
    t4 = <div className="relative w-full">{input}{t3}</div>;
    $[4] = input;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== message) {
    t5 = <TooltipPrimitive.Portal><TooltipPrimitive.Content side="top" align="center" sideOffset={4} className="max-w-[300px] px-2 py-1 text-wrap text-caption-3 text-quinary text-left rounded bg-tertiary shadow-md z-50">{message}</TooltipPrimitive.Content></TooltipPrimitive.Portal>;
    $[6] = message;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t4 || $[9] !== t5) {
    t6 = <TooltipPrimitive.Provider delayDuration={0}><TooltipPrimitive.Root>{t4}{t5}</TooltipPrimitive.Root></TooltipPrimitive.Provider>;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t2 || $[12] !== t6) {
    t7 = <div className="relative w-full flex flex-col items-center gap-4 md:gap-8">{t2}{t6}</div>;
    $[11] = t2;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
};
export default BlockedComposer;